import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Col } from "react-bootstrap";
import { CadastrarDespesaParceladaGroupPayForm } from "types/reactHookForm/formTypes/CadastrarDespesaParceladaGroupPayForm";
import SelectAsync from "shared/components/select/SelectAsync";
import { api } from "constants/RotasAPI";
import CustomSelect from "shared/components/select/CustomSelect";
import { getOpcoesPagamento } from "./SecaoDadosDespesaModalCadastrarDespesaUnicaGroupPay";
import TextInput from "shared/components/input/TextInput";
import { useGetProximoChequeDisponivel } from "hooks/groupPay/useGetProximoChequeDisponivel";

interface CamposPagamentoParcelaProps {
  index: number;
  condominioId: number;
}

const CamposPagamentoParcela: React.FC<CamposPagamentoParcelaProps> = ({ index, condominioId }) => {
  const { watch, setValue, register, control } = useFormContext<CadastrarDespesaParceladaGroupPayForm>();

  const nomeCampoConta = `parcelas.${index}.conta` as const;
  const nomeCampoFormaPagamento = `parcelas.${index}.formaPagamento` as const;
  const nomeCampoTipoPix = `parcelas.${index}.tipoFormaPagamentoPix` as const;
  const nomeCampoNumeroCheque = `parcelas.${index}.numeroCheque` as const;

  const formaPagamento = watch(nomeCampoFormaPagamento);

  const conta = watch(nomeCampoConta);
  const opcoesFormaPagamento = useMemo(() => getOpcoesPagamento(conta?.value), [conta]);
  const { data: proximoCheque } = useGetProximoChequeDisponivel(conta?.value?.contaBancaria?.id);

  useEffect(() => {
    setValue(nomeCampoFormaPagamento, null);
    setValue(nomeCampoTipoPix, null);
  }, [conta, setValue, nomeCampoFormaPagamento, nomeCampoTipoPix]);

  useEffect(() => {
    if (proximoCheque?.numero) {
      setValue(nomeCampoNumeroCheque, proximoCheque.numero.toString());
    } else {
      setValue(nomeCampoNumeroCheque, "");
    }
  }, [proximoCheque, setValue, nomeCampoNumeroCheque]);

  return (
    <>
      <Col xs={6} md={3}>
        <SelectAsync
          id={`conta-despesa-parcelada-${index}`}
          label="Conta"
          name={nomeCampoConta}
          control={control}
          register={register}
          setValue={setValue}
          endpoint={`${api.conta.getContasByCondominio}/${condominioId}?ativo=true`}
          nomeAtributoValue="conta"
          nomeAtributoLabel="conta.descricao"
          usarValidacaoParaFormulario
          isClearable={true}
        />
      </Col>
      <Col xs={6} md={formaPagamento?.value === "CHEQUE" ? 4 : 8}>
        <CustomSelect
          id={`forma-pagamento-despesa-parcelada-${index}`}
          label="Forma de pagamento"
          name={nomeCampoFormaPagamento}
          options={opcoesFormaPagamento}
          control={control}
          register={register}
          setValue={setValue}
          usarValidacaoParaFormulario
          onChange={(opcao) => {
            if (opcao?.value === "PIX") {
              setValue(nomeCampoTipoPix, "TRANSFERENCIA");
            } else {
              setValue(nomeCampoTipoPix, null);
            }
          }}
          isClearable={true}
        />
      </Col>
      {formaPagamento?.value === "CHEQUE" && (
        <Col xs={3}>
          <TextInput
            usarValidacaoParaFormulario={true}
            id={`numeroCheque-${index}`}
            label="Número do cheque"
            name={nomeCampoNumeroCheque}
            control={control}
            setValue={setValue}
            register={register}
          />
        </Col>
      )}
    </>
  );
};

export default CamposPagamentoParcela;
